module.exports = __webpack_public_path__ + "img/30290-8.prt.3c7a5be4.jpg";